<nav class="bg-primary">
  <div>
    <a class="logo" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">BYTEX</a>
    <span class="premium">Premium</span>
    <span class="beta">Beta</span>
  </div>
  @if (isLoggdIn) {
    <div class="wrap">
      <div>
        @if (showIfIsInUserType([UserType.SysAdmin, UserType.CustomerUser])) {
          <button mat-small mat-flat-button
          color="primary" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Hem</button>
        }
        <!-- Admin dropdown -->
        @if (accountService.hasPermission('admin',actionType.Create)) {
          <app-nav-button-menu
        [buttonName]="'Admin'" [menuOptions]="[
          { name: 'Admin startsida', route: '/admin' },
          { name: 'Användare & Roller', route: '/admin/users' },
          { name: 'Organisation', route: '/admin/company' }
        ]"></app-nav-button-menu>
        }
        <!-- Supplier Invoices dropdown -->
        @if (accountService.hasPermission('invoices',actionType.Read)) {
          <app-nav-button-menu
        [buttonName]="'Leverantörsfakturor'" [menuOptions]="[
          { name: 'Fakturor (import)', route: '/invoice/invoices' },
          { name: 'Underlag', route: '/invoice/re-invoices' },
          { name: 'Underlag (global)', route: '/invoice/underlag' },
          { name: 'Allokering (dummy)', route: '/supplier-invoices/allocation' },
          { name: 'Markup-regler', route: '/supplier-invoices/markups' },
          { name: 'Export (dummy)', route: '/supplier-invoices/exports' }
        ]"></app-nav-button-menu>
        }
        @if (showProjectNavMenu()) {
          <app-nav-button-menu
            [buttonName]="'Projekt'" [menuOptions]="projectNavMenuOptions"></app-nav-button-menu>
        }
        @if (showCustomersNavMenu()) {
          <app-nav-button-menu
            [buttonName]="'Kunder'" [menuOptions]="[{ name: 'Kundlista', route: '/customers' }]"></app-nav-button-menu>
        }
        @if (timeNavMenuOptions.length > 0) {
          <app-nav-button-menu
            [buttonName]="'Tid'" [menuOptions]="timeNavMenuOptions"></app-nav-button-menu>
        }
        @if (showIfIsInUserType([UserType.SysAdmin, UserType.DeveloperUser, UserType.ProductUpdator, UserType.TimeReportingUser, UserType.PunchClockUser])) {
          <app-nav-button-menu
        [buttonName]="'Inköp'" [menuOptions]="[
        { name: 'Ny inköp', route: '/purchases/new' },
        { name: 'Inköpslista', route: '/purchases' }
      ]"></app-nav-button-menu>
        }
        <!-- Supplier Invoices additions now in dropdown above -->
        <!-- Customers moved under Admin dropdown above -->
        <!-- Reports -->
        @if (showIfIsInUserType([UserType.SysAdmin, UserType.DeveloperUser, UserType.ProductUpdator])) {
          <app-nav-button-menu
        [buttonName]="'Rapporter'" [menuOptions]="[
        { name: 'Tid per projekt', route: '/reports/time-by-project' },
        { name: 'Inköp per projekt', route: '/reports/purchases-by-project' }
      ]"></app-nav-button-menu>
        }
      </div>
      <div>
        <button mat-flat-button color="primary" (click)="logout()">Logga ut</button>
      </div>
    </div>
  }
</nav>